import React, { useState, useEffect, useRef } from 'react';
import './PerformanceCount.css';
import CountUp from 'react-countup';
import { useTranslation } from 'react-i18next';

const PerformanceCount = () => {
    const { t, i18n } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const countSectionRef = useRef(null);

    const performanceCount = [
        { id:1,count: 350, title: 'Productions' },
        { id:2,count: 12, title: 'Viewers' },
        { id:3,count: 50, title: 'Partners' },
        { id:4,count: 235, title: 'Projects' },
    ];

    useEffect(() => {
        const currentRef = countSectionRef.current;
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); // Stop observing once it's visible
                }
            },
            { threshold: 0.3 } // Trigger when 30% of the component is visible
        );
        
        if (currentRef) {
            observer.observe(countSectionRef.current);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    return (
        <div className="performance-count-main-section" ref={countSectionRef}>
            <div className="performance-count-inner">
                {performanceCount.map((items, index) => (
                    <div
                        key={index}
                        className={(items.id === 1 || items.id === 3) ? 'performance-count-containt active' : 'performance-count-containt'}
                    >
                        <h3>
                            {isVisible && <CountUp end={items.count} />}
                             {items.id === 2 ? "M+" : "+"}
                        </h3>
                        <p>{t(`performancecount.${items.title}`)}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PerformanceCount;
